// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_n0-0";